// src/contexts/RealtimeContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';

const RealtimeContext = createContext(null);

export function RealtimeProvider({ children }) {
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    // will connect to same host & port as your page
    const s = io({ autoConnect: true });
    setSocket(s);

    return () => {
      s.disconnect();
    };
  }, []);

  return (
    <RealtimeContext.Provider value={socket}>
      {children}
    </RealtimeContext.Provider>
  );
}

export function useRealtime() {
  const socket = useContext(RealtimeContext);
  if (!socket) throw new Error("useRealtime must be within a RealtimeProvider");
  return socket;
}
